const Features = () => {
    return (
        <section className="mb-12 container mx-auto">
            <h3 className="text-2xl font-bold mb-6 text-text-dark text-center">Why Choose BusExpress?</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Safe Travel Card */}
                <div className="feature-card bg-white rounded-xl p-6 shadow-card text-center">
                    <div className="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center mx-auto mb-4">
                        <i className="fas fa-shield-alt text-white text-2xl"></i>
                    </div>
                    <h4 className="text-xl font-bold mb-3 text-text-dark">Safe Travel</h4>
                    <p className="text-text-light">All buses are sanitized and drivers are verified with safety protocols in place for your secure journey.</p>
                </div>

                {/* Comfortable Seats Card */}
                <div className="feature-card bg-white rounded-xl p-6 shadow-card text-center">
                    <div className="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center mx-auto mb-4">
                        <i className="fas fa-couch text-white text-2xl"></i>
                    </div>
                    <h4 className="text-xl font-bold mb-3 text-text-dark">Comfortable Seats</h4>
                    <p className="text-text-light">Enjoy spacious and cushioned seats that ensure a comfortable and relaxing ride for all passengers.</p>
                </div>

                {/* Affordable Pricing Card */}
                <div className="feature-card bg-white rounded-xl p-6 shadow-card text-center">
                    <div className="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center mx-auto mb-4">
                        <i className="fas fa-dollar-sign text-white text-2xl"></i>
                    </div>
                    <h4 className="text-xl font-bold mb-3 text-text-dark">Affordable Pricing</h4>
                    <p className="text-text-light">We offer competitive pricing without compromising on quality. Travel more for less!</p>
                </div>

               
            </div>
        </section>
    );
};

export default Features;
